import React, { useState, useEffect, useCallback } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import 'react-toastify/dist/ReactToastify.css'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Requests from '../../../../utils/Requests/Index'

import LoadingComponent from '../../../../components/loading/Index'

const Edit = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [error, setError] = useState(null)
    const [isLoading, setLoading] = useState(true)
    const [update, setUpdate] = useState(false)
    const [item, setItem] = useState(null)
    const [selectedFile, setSelectedFile] = useState(null)
    const [sections, setSections] = useState([]);
    const [faq, setFaq] = useState([]);
    const [uploading, setUploading] = useState({});
    const [uploadingCount, setUploadingCount] = useState(0);
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Fetch data
    const fetchData = useCallback(async () => {
        const data = await Requests.Blog.Show(id, header)
        // console.log(data);
        
        if (data) {
            setItem(data)
            setSections(data.sections || []);
            setFaq(data.faq || []);
            setLoading(false)
        }
        setLoading(false)
    }, [id, header])

    useEffect(() => {
        fetchData()
    }, [id, header, fetchData])

    // Handle image
    const handleImage = async (event) => {
        const file = event.target.files[0]
        if (file) {
            // const size = parseInt(file.size) / 1000
            // if (size > 800) {
            //     setError({ ...error, image: 'Select less than 800KB file.' })
            //     return
            // }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })

            let formData = new FormData()
            formData.append('image', file)
            setItem({ ...item, image: null })

            const response = await Requests.Blog.UpdateImage(id, formData, header)
            if (response.status === true) {
                toast.success(response.message)
            }
        }
    }

        // Upload Image
    const UploadImage = async (event) => {
    try {
        const file = event.target.files[0];

        if (!file) return null;

        // const size = file.size / 1024;

        // if (size > 500) {
        //     setError(prev => ({
        //         ...prev,
        //         image: 'Select less than 500KB file.'
        //     }));

        //     return null;
        // }

        const formData = new FormData();

        formData.append('image', file);

        const image = await Requests.Blog.StoreImage(
            formData,
            header
        );

        return image;

    } catch (error) {
        console.log(error);
        return null;
    }
};

    const removeSection = index => {
        const data = [...sections]
        data.splice(index, 1)
        setSections(data)
    }

        // Sections
    const addSection = () => {
        setSections([
            ...sections,
            {
                title: '',
                description: '',
                image: '',
                preview: '',
                uploading: false
            }
        ])
    }

    //    const handleSectionChange = (index, field, value) => {
    //     const data = [...sections]
    //     data[index][field] = value
    //     setSections(data)
    // }

    const handleSectionChange = (index, field, value) => {
    setSections(prev =>
        prev.map((section, i) =>
            i === index
                ? { ...section, [field]: value }
                : section
        )
    );
};

    // FAQ
    const addFaq = () => {
        setFaq([
            ...faq,
            {
                question: '',
                answer: ''
            }
        ])
    }

    const removeFaq = index => {
        const data = [...faq]
        data.splice(index, 1)
        setFaq(data)
    }

    const handleFaqChange = (index, field, value) => {
        const data = [...faq]
        data[index][field] = value
        setFaq(data)
    }

    // Submit Form
    const onSubmit = async (data) => {
        try {
            const payload = {
                title: data.title,
                link: data.link,
                description: data.description,
                metaTitle: data.metaTitle,
                metaDescription: data.metaDescription,
                keywords: data.keywords,
                sections,
                faq
            };
            
            setUpdate(true)
            await Requests.Blog.Update(id, payload, header)
            
            setUpdate(false)
            navigate("/dashboard/website/blog")
        } catch (error) {
            if (error) console.log(error)
        }
    }

    if (isLoading) return <LoadingComponent />

    return (
        <div className="store-blog pb-4">

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Edit blog</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/blog"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">

                                        {/* Image upload Container */}
                                    <div className="form-group mb-4">
                                        {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Image</p>}
                                        <div className="d-flex">
                                            {item && item.image ?
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={item.image} className="img-fluid" alt="..." />
                                                    </div>
                                                </div>
                                                : selectedFile ?
                                                    <div className="img-container text-center mr-2">
                                                        <div className="image border">
                                                            <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                        </div>
                                                    </div>
                                                    : null}

                                            <div className="img-container text-center">
                                                <div className="image border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                        {/* Title */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.title && errors.title.message ? (
                                                    <p className="text-danger">{errors.title && errors.title.message}</p>
                                                ) : <p>Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="title"
                                                    defaultValue={item.title}
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Title"
                                                    {...register("title",{ required: "Title is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* link */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.link && errors.link.message ? (
                                                    <p className="text-danger">{errors.link && errors.link.message}</p>
                                                ) : <p>Link</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="link"
                                                    defaultValue={item.link}
                                                    className="form-control shadow-none"
                                                    placeholder="Enter link"
                                                    {...register("link",{ required: "Link is required" })}
                                                />
                                            </div>
                                        </div>

                                    </div>

                                    {/* description */}
                                    <div className="form-group mb-4">
                                        {errors.description && errors.description.message ? (
                                            <p className="text-danger">{errors.description && errors.description.message}</p>
                                        ) : <p>Description</p>}

                                        <textarea
                                            type="text"
                                            name="description"
                                            rows={5}
                                            defaultValue={item.description}
                                            className="form-control shadow-none"
                                            placeholder="Enter blog description"
                                            {...register("description",{ required: "Description is required" })}
                                        />
                                    </div>

                                    <div className="row">

                                <div className="col-lg-12">
                                    <div className="form-group mb-4">
                                        <p>Meta Title</p>

                                        <input
                                            type="text"
                                            defaultValue={item.metaTitle}
                                            className="form-control"
                                            {...register(
                                                'metaTitle'
                                            )}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="form-group mb-4">
                                        <p>
                                            Meta Description
                                        </p>

                                        <textarea
                                            defaultValue={item.metaDescription}
                                            rows={3}
                                            className="form-control"
                                            {...register(
                                                'metaDescription'
                                            )}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="form-group mb-4">
                                        <p>
                                            Keywords
                                        </p>

                                        <textarea
                                            defaultValue={item.keywords}
                                            rows={3}
                                            className="form-control"
                                            {...register(
                                                'keywords'
                                            )}
                                        />
                                    </div>
                                </div>

                                {sections.map(
                                    (section, index) => (
                                        <div
                                            key={index}
                                            className="border p-3 mb-3"
                                        >
                                        <div className="d-flex align-items-start gap-3 mb-3">

                                            <div className="img-container mb-3 text-start">
                                                <div className="image border">

                                                    <input
                                                        type="file"
                                                        className="upload"
                                                        onChange={async (e) => {
                                                        setUploadingCount(prev => prev + 1);

                                                        setUploading(prev => ({
                                                            ...prev,
                                                            [index]: true,
                                                        }));

                                                        try {
                                                            const image = await UploadImage(e);

                                                            if (!image) return;

                                                            setSections(prev =>
                                                                prev.map((section, i) =>
                                                                    i === index
                                                                        ? {
                                                                            ...section,
                                                                            image,
                                                                            preview: URL.createObjectURL(e.target.files[0]),
                                                                        }
                                                                        : section
                                                                )
                                                            );
                                                        } catch (error) {
                                                            console.error(error);
                                                        } finally {
                                                            setUploading(prev => ({
                                                                ...prev,
                                                                [index]: false,
                                                            }));

                                                            setUploadingCount(prev => prev - 1);
                                                        }
                                                    }}
                                                        // onChange={async (e) => {
                                                        //     const image = await UploadImage(e);

                                                        //     if (!image) return;

                                                        //     // const data = [...sections];

                                                        //     setSections(prev =>
                                                        //         prev.map((section, i) =>
                                                        //             i === index
                                                        //                 ? {
                                                        //                     ...section,
                                                        //                     image,
                                                        //                     preview: URL.createObjectURL(e.target.files[0])
                                                        //                 }
                                                        //                 : section
                                                        //         )
                                                        //     );
                                                        // }}
                                                    />

                                                    <div className="flex-center flex-column">
                                                        <Icon
                                                            icon={plus}
                                                            size={22}
                                                        />
                                                    </div>

                                                </div>
                                            </div>


                                            {uploading[index] ? (
                                                <div
                                                    className="border rounded d-flex align-items-center justify-content-center"
                                                    style={{ width: 120, height: 120 }}
                                                >
                                                    Uploading...
                                                </div>
                                            ) : (section.preview || section.image) ? (
                                                <img
                                                    src={
                                                        section.preview
                                                            ? section.preview
                                                            : `${process.env.REACT_APP_IMAGE_URL}/${section.image}`
                                                    }
                                                    alt="Preview"
                                                    className="border rounded"
                                                    style={{
                                                        width: 120,
                                                        height: 120,
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : null}

                                            {/* {(section.preview || section.image) && (
                                                    <img
                                                        src={ section.preview || `${process.env.REACT_APP_IMAGE_URL}/${section.image}` }
                                                        alt="Preview"
                                                        className="border rounded"
                                                        style={{
                                                            width: "120px",
                                                            height: "120px",
                                                            objectFit: "cover"
                                                        }}
                                                    />
                                                )} */}

                                            {/* {item.preview && (
                                                <img
                                                    src={item.preview}
                                                    alt="Preview"
                                                    className="border rounded"
                                                    style={{
                                                        width: "120px",
                                                        height: "120px",
                                                        objectFit: "cover"
                                                    }}
                                                />
                                            )} */}

                                        </div>
                                        

                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                // defaultValue={item.title}
                                                placeholder="Section Title"
                                                value={
                                                    section.title
                                                }
                                                onChange={e =>
                                                    handleSectionChange(
                                                        index,
                                                        'title',
                                                        e.target
                                                            .value
                                                    )
                                                }
                                            />
                                            <ReactQuill
                                                theme="snow"
                                                // style={{
                                                //     height: '150px'
                                                // }}
                                                className="mb-2"
                                                placeholder="Section Description"
                                                value={section.description}
                                                onChange={(value) =>
                                                    handleSectionChange(
                                                        index,
                                                        "description",
                                                        value
                                                    )
                                                }
                                            />


                                            <div className="mt-3">
                                                <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() =>
                                                    removeSection(
                                                        index
                                                    )
                                                }
                                            >
                                                Remove
                                            </button>
                                            </div>

                                            
                                        </div>
                                    )
                                )}

                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={
                                            addSection
                                        }
                                    >
                                        Add Section
                                    </button>
                                </div>

                            </div>

                             {/* FAQ */}

                            <div className="mb-4">

                                <div className="d-flex justify-content-between mb-3">
                                    <h5>FAQ</h5>

                                    
                                </div>

                                {faq.map(
                                    (item, index) => (
                                        <div
                                            key={index}
                                            className="border p-3 mb-3"
                                        >
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder="Question"
                                                value={
                                                    item.question
                                                }
                                                onChange={e =>
                                                    handleFaqChange(
                                                        index,
                                                        'question',
                                                        e.target
                                                            .value
                                                    )
                                                }
                                            />

                                            <textarea
                                                rows={3}
                                                className="form-control mb-2"
                                                placeholder="Answer"
                                                value={
                                                    item.answer
                                                }
                                                onChange={e =>
                                                    handleFaqChange(
                                                        index,
                                                        'answer',
                                                        e.target
                                                            .value
                                                    )
                                                }
                                            />

                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() =>
                                                    removeFaq(
                                                        index
                                                    )
                                                }
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    )
                                )}
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={addFaq}
                                    >
                                        Add FAQ
                                    </button>
                                </div>
                            </div>

                                    

                                    <div className="text-end">
                                        <button
                                        type="submit"
                                        className="btn shadow-none"
                                        disabled={update || uploadingCount > 0}
                                    >
                                        {update
                                            ? "Updating..."
                                            : uploadingCount > 0
                                            ? `Uploading ${uploadingCount} Image${uploadingCount > 1 ? "s" : ""}...`
                                            : "Update"}
                                    </button>
                                        {/* <button type="submit" className="btn shadow-none" disabled={update}>
                                            {update ? 'Updating...' : 'Update'}
                                        </button> */}
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Edit;
